<template>
  <div >
    <Header />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/ui/Header.vue'
import Footer from '@/components/ui/Footer.vue'
export default {
  components: {
    Header,
    Footer
  }
}
</script>